<template>
  <lb-drawer
    :value="visible"
    heading="Remove User"
    width="500"
    :loading="loading"
    data-testid="remove-team-member-drawer"
    @input="$emit('update:visible', $event)"
  >
    <template #body>
      <div data-testid="remove-team-member-drawer__body">
        <div class="mb-3" data-testid="remove-team-member-drawer__selecteduser-row">
          <span class="font-weight-bold mr-2">Selected User:</span>
          <span data-testid="remove-team-member-drawer__selecteduser">{{ userName }}</span>
        </div>
        <div
          v-if="showTaskWarning"
          data-testid="remove-team-member-drawer__warning"
        >
          Since the user is also associated to various tasklist items, all those association will be removed if the user is removed from the project.
        </div>
        <div v-else data-testid="remove-team-member-drawer__warning-alt">
          This will remove the user from the current project.
        </div>
        <div class="font-weight-bold" data-testid="remove-team-member-drawer__warning-confirm">
          Do you want to proceed?
        </div>
      </div>
    </template>
    <template #actions>
      <v-spacer />
      <v-btn
        color="primary"
        class="white--text"
        data-testid="remove-team-member-drawer__remove-btn"
        @click="$emit('submit')"
      >
        <span data-testid="remove-team-member-drawer__remove-label">Remove</span>
      </v-btn>
    </template>
  </lb-drawer>
</template>

<script>
export default {
  name: 'RemoveTeamMemberDrawer',
  props: {
    visible: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    userName: { type: String, default: 'Unknown' },
    showTaskWarning: { type: Boolean, default: false }
  },
  emits: ['update:visible', 'submit']
};
</script>
